/* eslint-disable import/prefer-default-export */
export const getFieldName = (obj: any, fieldId: any) => {
    for (const key in obj) if (obj[key].id === Number(fieldId)) return key;
    return 'not found';
};
